import Vue from 'vue'
import VueAxios from 'vue-axios'
// axios
import axios from 'axios'
import authService from '@/core/auth/AuthService'

const axiosIns = axios.create({
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
})

axiosIns.interceptors.request.use(
    config => {
        const token = authService.getToken()
        if (token) {
            // Добавляем токен в заголовок
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },
    error => Promise.reject(error)
)

let isRefreshing = false
let failedQueue = []

const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error)
        } else {
            prom.resolve(token)
        }
    })
    failedQueue = []
}

axiosIns.interceptors.response.use(
    response => response, // Если ответ успешный, просто пробрасываем его дальше
    async error => {
        const originalRequest = error.config

        // Если пришла ошибка 401 и это не повторный запрос
        if (error.response?.status === 401 && !originalRequest._retry) {
            if (isRefreshing) {
                // Если токен УЖЕ обновляется, становимся в очередь, чтобы не слать 100 запросов на обновление
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject })
                }).then(token => {
                    originalRequest._retry = true // Не входим в 401-обработчик повторно
                    originalRequest.headers.Authorization = `Bearer ${token}`
                    return axiosIns(originalRequest)
                })
            }

            originalRequest._retry = true // Помечаем запрос как "повторный"
            isRefreshing = true

            try {
                // Форсируем обновление токена через Keycloak
                const refreshed = await authService.updateToken(30, true)
                const newToken = authService.getToken()

                // Токен перевыпущен или ещё валиден — повторяем запрос один раз
                if (refreshed || newToken) {
                    originalRequest.headers.Authorization = `Bearer ${newToken}`

                    // Повторяем все запросы из очереди с новым токеном
                    processQueue(null, newToken)

                    // Повторяем оригинальный запрос
                    return axiosIns(originalRequest)
                }
            } catch (e) {
                processQueue(e, null)
                // updateToken() выбросил ошибку — сессия действительно мертва,
                // logout уже выполнен внутри updateToken. Просто пробрасываем ошибку.
                return Promise.reject(e)
            } finally {
                isRefreshing = false
            }
        }

        // Для всех других ошибок (404, 500, повторный 401, и т.д.) просто пробрасываем их дальше
        return Promise.reject(error)
    }
)

Vue.use(VueAxios, axiosIns)

export default axiosIns
